// Rubros/industrias disponibles para auspiciantes.
// Se usa para evitar que dos auspiciantes de la misma industria queden en secuencia dentro de un evento.
export const SPONSOR_INDUSTRIES = [
  "Alimentos y bebidas",
  "Automotriz",
  "Banca y finanzas",
  "Belleza y cuidado personal",
  "Construcción y ferretería",
  "Deportes",
  "Educación",
  "Entretenimiento",
  "Hogar y decoración",
  "Inmobiliaria",
  "Moda y vestimenta",
  "Salud y farmacia",
  "Servicios públicos",
  "Supermercados y retail",
  "Tecnología y telecomunicaciones",
  "Turismo y viajes",
  "Otro",
] as const;
